/**
 * Checkout API Endpoints
 * Functions for Stripe checkout session management
 */

import { apiClient } from "../client";
import type {
  ApiResult,
  CheckoutSession,
  CreateCheckoutSessionRequest,
  RequestOptions,
} from "../types";

/**
 * Create a new Stripe checkout session for subscription
 * @param params - Checkout session parameters
 * @param options - Request options
 * @returns The checkout session with client_secret for Stripe Elements
 */
export async function createCheckoutSession(
  params: CreateCheckoutSessionRequest,
  options?: RequestOptions,
): Promise<ApiResult<CheckoutSession>> {
  return apiClient.post<CheckoutSession>("/checkout/session", params, options);
}

// Export as a namespaced object for organized imports
export const checkoutApi = {
  createSession: createCheckoutSession,
};

export default checkoutApi;
